export default __webpack_public_path__ + "static/media/view04.61edbf99.jpg";